import { Component, OnInit } from '@angular/core';
import { ApiConnectionService } from '../services/api-connection.service'
import { FormGroup, FormControl, Validators, FormBuilder } from '@angular/forms';
import { TranslateServiceService } from '../services/translate-service.service';
import { LoginService } from '../services/login.service';

@Component({
  selector: 'app-join-up',
  templateUrl: './join-up.component.html',
  styleUrls: ['./join-up.component.scss']
})
export class JoinUpComponent implements OnInit {

  sectionActive: boolean = false;
  approvedRecord: boolean = true;

  // NgModels
  name: string;
  lastName: string;
  email: string;
  confirmEmail: string;
  password: string;
  confirmPassword: string;
  msg: string;
  teamId: string;
  cardImg: string;
  collectorImg: string;
  selectedTeam: any;

  // Config
  logoRace: string;
  hasAvatar: boolean = false;
  hasBanner: boolean = false;
  isUpdatePage: boolean = false;

  // Team
  teamList: any;

  // Base64 stuffs
  avatarBase64: any = "";
  bannerBase64: any = "";
  avatarFile: any;
  bannerFile: any;

  // Validations
  checkoutForm: FormGroup;
  emailRegex: any = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  emptyFieldJoin: boolean = false;
  passwordsErr: boolean = false;
  teamErr: boolean = false;
  emailsErr: boolean = false;
  serverErr: boolean = false;
  avatarErr: boolean = false;
  bannerErr: boolean = false;
  avatarSizeErr: boolean = false;
  bannerSizeErr: boolean = false;
  captchaErr: boolean = false;
  serverErrTextFlag: boolean = false;
  emailForm: string = '';

  serverErrText: string;

  // Change View
  collectorCreated: boolean = false;

  // Loader
  showLoader: boolean = false;

  // Color Theme
  goalBarBg: any;

  // Global loader
  arePageReady: boolean = false;

  // Translate Service
  text: any = {};
  notCurrentLanguage: string;
  currentLanguageNav

  // Captcha
  captchaApproved: string = '';

  // Pass input
  donorPastInput: any;

  // Login service
  showLogin: boolean = false;

  // Login config
  lCollectorTeam: string = '';
  lCollectorUrl: string = '';
  lCollectorUpdateUrl: string = '';
  lCollectorToken: string = '';
  lCollectorId: string;

  // Login err
  serverErrLoginText: string = '';
  serverErrLogin: boolean = false;
  emptyFieldLogin: boolean = false;
  errEmailLogin: boolean = false;

  // Form Validations
  loginForm: FormGroup;
  showLoginLoader: boolean = false;

  constructor(
    private apiService: ApiConnectionService,
    private translateService: TranslateServiceService,
    private loginService: LoginService
  ) {
    let _ = this;
    _.getCurrentLanguage();
  }

  ngOnInit() {
    let _ = this;
    _.checkoutValidationForm();
    _.getToken();
    _.isUpdate();
    _.checkoutLoginValidationForm();
    window.scrollTo(0, 0)
  }

  ngAfterViewInit(){
    let _ = this;
    _.getTeams();
    _.getQuantities();
  }

  checkoutLoginValidationForm(){
    let _ = this;
    _.loginForm = new FormGroup({
      email: new FormControl('', Validators.required),
      password: new FormControl('', Validators.required),
    });
  }

  isUpdate(){
    let _ = this;
    let whatPageIs: any = location.href.split('/');
    whatPageIs = whatPageIs[5];
    if (whatPageIs == 'update'){
      _.isUpdatePage = true;
    }
  }

  getToken(){
    let _ = this;
    _.lCollectorTeam = localStorage.getItem('teamC');
    _.lCollectorUrl = localStorage.getItem('userUrlC');
    _.lCollectorToken = localStorage.getItem('tokenL');
    _.lCollectorId = localStorage.getItem('userIdC');
  }

  getCurrentLanguage() {
    let _ = this;
    let isEN = _.translateService.getCurrentLanguage() === 'EN';
    _.translateService.getJSON("assets/translations/join-up.translations.json")
      .subscribe((res)=> {
        if(isEN){
          _.text = res.english;
          _.notCurrentLanguage = 'ES';
          _.currentLanguageNav = 'en';
        }else{
          _.text = res.spanish;
          _.notCurrentLanguage = 'EN';
          _.currentLanguageNav = 'es';
        }
      });
  }

  checkoutValidationForm(){
    let _ = this;
    _.checkoutForm = new FormGroup({
      //Info Step
      nameJoin: new FormControl('nameJoin', Validators.required),
      lastNameJoin: new FormControl('lastNameJoin', Validators.required),
      emailJoin: new FormControl('lastNameJoin', Validators.required),
      confirmEmailJoin: new FormControl('confirmEmailJoin', Validators.required),
      passwordJoin: new FormControl('passwordJoin', Validators.required),
      confirmPasswordJoin: new FormControl('confirmPasswordJoin', Validators.required),
    });
  }

  getQuantities(){
    let _ = this;
    let conditions = {
      "conditions":{
        "race_url": _.getRaceName(),
        "active": true,
      },
      "merchant": _.getMerchant(),
    }

    _.apiService.getQuantities(conditions).subscribe(data => {
      _.logoRace = data['results'][0].design.images.logo_header;
      _.goalBarBg = data['results'][0].design.color.secundary;
      setTimeout(() => {
        _.arePageReady = true;
      }, 1000)
    })
  }

  withoutSpaces(){
    let _ = this;
    _.email = _.email.replace(' ','');
    _.confirmEmail = _.confirmEmail.replace(' ','');
  }

  updateCollector(){
    let _ = this;
    let conditions = {
    	"collector": {
        "description": _.msg,
        "password": _.password,
        "avatar": _.avatarBase64,
        "banner": _.bannerBase64,
    		"user_id": _.lCollectorId
    	},
    	"token": _.lCollectorToken
    }
    console.log(conditions)
    _.showLoader = true;
    _.apiService.updateCollector(conditions).subscribe(data => {
        console.log(data);
        _.showLoader = false;
        _.collectorCreated = true;
        window.scrollTo(0, 0);
      },
      err => {
        let err_desc: any;
        _.showLoader = false;
        _.serverErrTextFlag = true;
        _.serverErrText = err['error'].msg || err['error'].description;
        if(err['error'].description){
          err_desc = err['error'].description.split('-');
          err_desc = err_desc[1]
          err_desc = JSON.parse(err_desc);
          err_desc = err_desc.description;
          _.serverErrText = err_desc;
        }
      }
    )
  }
  cleanMail(){
    let _ = this;
    _.email = _.email.trim();
    _.confirmEmail = _.confirmEmail.trim();
  }

  createCollector(){
    let _ = this;
    let conditions = {
      "collector": {
        "fullname": _.name + ' ' + _.lastName,
        "email": _.email,
        "description": _.msg,
        "password": _.password,
        "team_id": _.teamId,
        "avatar": _.avatarBase64,
        "banner": _.bannerBase64
      },
      "merchant": _.getMerchant()
    }

    // if(_.captchaApproved == ''){
    //   _.captchaErr = true;
    //   _.emptyFieldJoin = false;
    //   _.passwordsErr = false;
    //   _.emailsErr = false;
    //   _.avatarErr = false;
    //   _.bannerErr = false;

    //   return
    // }

    if(_.checkoutForm.get('nameJoin').hasError('required')){
      _.emptyFieldJoin = true;
      _.passwordsErr = false;
      _.emailsErr = false;
      _.avatarErr = false;
      _.bannerErr = false;
      //_.captchaErr = false;

      return;
    }

    if(_.checkoutForm.get('lastNameJoin').hasError('required')){
      _.emptyFieldJoin = true;
      _.passwordsErr = false;
      _.emailsErr = false;
      _.avatarErr = false;
      _.bannerErr = false;
      //_.captchaErr = false;

      return;
    }

    if(_.checkoutForm.get('emailJoin').hasError('required')){
      _.emptyFieldJoin = true;
      _.passwordsErr = false;
      _.emailsErr = false;
      _.avatarErr = false;
      _.bannerErr = false;
      //_.captchaErr = false;

      return;
    }

    if(_.checkoutForm.get('confirmEmailJoin').hasError('required')){
      _.emptyFieldJoin = true;
      _.passwordsErr = false;
      _.emailsErr = false;
      _.avatarErr = false;
      _.bannerErr = false;
      //_.captchaErr = false;

      return;
    }

    if(_.checkoutForm.get('passwordJoin').hasError('required')){
      _.emptyFieldJoin = true;
      _.passwordsErr = false;
      _.emailsErr = false;
      _.avatarErr = false;
      _.bannerErr = false;
      //_.captchaErr = false;

      return;
    }

    if(_.checkoutForm.get('confirmPasswordJoin').hasError('required')){
      _.emptyFieldJoin = true;
      _.passwordsErr = false;
      _.emailsErr = false;
      _.avatarErr = false;
      _.bannerErr = false;
      //_.captchaErr = false;

      return;
    }

    if(_.password != _.confirmPassword){
      _.passwordsErr = true;
      _.emptyFieldJoin = false;
      _.emailsErr = false;
      _.avatarErr = false;
      _.bannerErr = false;

      return;
    }

    if(_.email != _.confirmEmail){
      _.passwordsErr = false;
      _.emptyFieldJoin = false;
      _.emailsErr = true;
      _.avatarErr = false;
      _.bannerErr = false;
      //_.captchaErr = false;

      return;
    }
    if(_.teamId == '' || _.teamId == undefined || _.teamId == null){
      _.teamErr = true;
      _.avatarErr = false;
      _.bannerErr = false;
      _.passwordsErr = false;
      _.emptyFieldJoin = false;
      _.emailsErr = false;
      //_.captchaErr = false;

      return;
    }

    if(_.validateSize(_.bannerFile, 'banner')){
      _.bannerSizeErr = true;
      _.avatarErr = false;
      _.bannerErr = false;
      //_.captchaErr = false;

      return;
    }

    if(_.validateSize(_.avatarFile, 'avatar')){
      _.avatarSizeErr = true;
      _.avatarErr = false;
      _.bannerErr = false;
      //_.captchaErr = false;

      return;
    }

    _.emptyFieldJoin = false;
    _.passwordsErr = false;
    _.emailsErr = false;
    _.avatarErr = false;
    _.bannerErr = false;
    _.bannerSizeErr = false;
    _.avatarSizeErr = false;
    //_.captchaErr = false;
    _.serverErrTextFlag = false;
    _.showLoader = true;

    _.apiService.createCollector(conditions).subscribe(data => {
        _.showLoader = false;
        _.collectorCreated = true;
        _.bannerBase64 = "";
        _.bannerFile = "";
        _.hasBanner = false;
        _.hasAvatar = false;
        _.avatarBase64 = "";
        _.avatarFile = "";
        window.scrollTo(0, 0);
      },
      err => {
        let err_desc: any;
        _.showLoader = false;
        _.serverErrTextFlag = true;
        _.serverErrText = err['error'].msg || err['error'].description;
        if(err['error'].description){
          err_desc = err['error'].description.split('-');
          err_desc = err_desc[1]
          err_desc = JSON.parse(err_desc);
          err_desc = err_desc.description;
          _.serverErrText = err_desc;
        }

      }
    )
  }

  getRaceName(){
    let _ = this;
    let raceName: any = location.href.split('/');

    return raceName[4];
  }

  getMerchant(){
    let _ = this;
    let merchant: any = location.href.split('/');

    return merchant[3];
  }

  getTeams(){
    let _ = this;
    let conditions = {
      "conditions":{
        "active": true,
        "race_url": _.getRaceName()
      },
      "merchant": _.getMerchant(),
    }

    _.apiService.getTeamInfo(conditions).subscribe(data => {
      _.teamList = data['results'];
      _.knowingDefaultTeam(_.teamList);
    })
  }

  knowingDefaultTeam(teams){
    let _ = this;
    for(let i = 0; i < teams.length; i++){
      if(teams[i].name == "No pertenezco a ningún grupo"){
        _.selectedTeam = i;
        _.teamId = teams[i].team_id;
      }
    }
  }

  getAvatar(){
    let _ = this;
    _.avatarFile = (document.querySelector('input[type=file]') as HTMLInputElement );
    _.avatarBase64F(_.avatarFile.files[0]);
    _.hasAvatar = true;
  }

  getBanner(){
    let _ = this;
    _.bannerFile = (document.querySelector('.container-input-file-banner') as HTMLInputElement );
    _.bannerBase64F(_.bannerFile.files[0]);
    _.hasBanner = true;
  }

  avatarBase64F(file){
    let _ = this;
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      _.avatarBase64 = reader.result
    };
    reader.onerror = function (error) {
      _.avatarBase64 = reader.result
    };
  }

  bannerBase64F(file){
    let _ = this;
    var reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      _.bannerBase64 = reader.result
    };
    reader.onerror = function (error) {
      _.bannerBase64 = reader.result
    };
  }

  goToHome(){
    let _ = this;
    location.href = '/' + _.getMerchant() + '/' + _.getRaceName();
  }

 validateSize(file, type) {
    let _ = this;
    let FileSize;
    if(type == 'banner' && !_.hasBanner){
      return false
    }

    if(type == 'avatar' && !_.hasAvatar){
      return false
    }

    FileSize = file.files[0].size / 1024 / 1024;

    if (type == 'banner' && FileSize > 2 && _.hasBanner) {
      return true;
    }
    if (type == 'avatar' && FileSize > 1 && _.hasAvatar) {
      return true;
    }

    return false;
  }

  // captchaIsResolved(captchaResponse: string) {
  //   let _ = this;
  //   _.captchaApproved = captchaResponse;
  // }

  upLabel(labelName, inputName){
    let _ = this;
    let labelTopUp = document.querySelector('.' + labelName);
    let allUpLabels = document.getElementsByClassName('label-up-active');
    let inputToFocus = document.querySelector('.' + inputName);

    (<HTMLInputElement>inputToFocus).focus();
    labelTopUp.classList.add('label-up-active');
    _.donorPastInput = inputToFocus;
  }

  downLabel(labelName, inputName){
    let placeholderElement = document.querySelector('.' + labelName);
    let inputPlaceholderElement = (<HTMLInputElement>document.querySelector('.' + inputName));

    if(inputPlaceholderElement.value == ''){
      placeholderElement.classList.remove('label-up-active');
    }
  }

  changeTeamId(){
    let _ = this;
    for(let i = 0; i < _.teamList.length; i++){
      if(i == _.selectedTeam){
        _.teamId = _.teamList[i].team_id;
      }
    }
  }

  createLogin(){
    let _ = this;
    let loginConditions = {
    	"user":{
    		"email": _.loginForm.controls.email.value,
    		"password": _.loginForm.controls.password.value
    	},
    	"merchant": _.getMerchant(),
      "race_url":_.getRaceName()
    }

    if(_.loginForm.get('email').hasError('pattern')){
      _.errEmailLogin = true;
      _.emptyFieldLogin = false;

      return;
    }

    if(_.loginForm.get('email').hasError('required')){
      _.emptyFieldLogin = true;
      _.errEmailLogin = false;

      return;
    }

    if(_.loginForm.get('password').hasError('required')){
      _.emptyFieldLogin = true;
      _.errEmailLogin = false;

      return;
    }
    _.emptyFieldLogin = false;
    _.errEmailLogin = false;
    _.showLoginLoader = true;

    _.apiService.createLogin(loginConditions).subscribe(data => {
        localStorage.setItem('tokenL', data['token']);
        localStorage.setItem('avatarC', data['user_id'].avatar);
        localStorage.setItem('emailC', data['user_id'].email);
        localStorage.setItem('userIdC', data['user_id'].user_id);
        localStorage.setItem('teamC', data['user_id'].team_url);
        localStorage.setItem('userUrlC', data['user_id'].collector_url);
        localStorage.setItem('userFullNameC', data['user_id'].full_name);
        location.href = "/" + _.getMerchant() + "/" + _.getRaceName();
        _.showLoginLoader = false;
      },
      err => {
        _.serverErrLoginText = err['error'].msg;
        _.serverErrLogin = true;
        _.showLoginLoader = false;
      }
    )
  }

  resetLoginFields(){
    let _ = this;
    _.loginForm.reset();
    _.serverErrLogin = false;
    _.emptyFieldLogin = false;
    _.errEmailLogin = false;
  }
}
